import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import api from './api'
// 短期票据（X-Ticket）接入：注册 axios 拦截器，业务代码透明。
// 注意：必须在 api（其内 http.js 已注册拦截器）之后导入，
// 保证票据相关拦截器在响应链上先于 http.js 的 401 通用处理执行。
import './api/ticket'
import ElementUI from 'element-ui'
import i18n from './i18n'
import VueClipboard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icons/iconfont.css'
import './assets/font/fonts.css'
import './assets/styles/custom.scss'

//全局注册
Vue.use(ElementUI,{
  i18n: (key, value) => i18n.t(key, value) 
});
Vue.use(VueClipboard)  //剪切板工具

Vue.config.productionTip = false

// 全局变量
Vue.prototype.$api = api


let startApp = function(){
  axios.get('/data/config.json').then((res) => {
    // 基础地址
    Vue.prototype.$ws_ip = res.data.ws_ip;
    Vue.prototype.$ipurl = res.data.ip;
    Vue.prototype.$ip_activation = res.data.ip_activation;
    axios.defaults.baseURL = res.data.ip;

    new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app')

  })
}

startApp()